import {
  Box,
  Text,
  Avatar,
  Spacer,
  Popover,
  PopoverTrigger,
  Button,
  PopoverArrow,
  PopoverCloseButton,
  PopoverHeader,
  PopoverBody,
  PopoverContent,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from '@chakra-ui/react';
import shallow from 'zustand/shallow';
import { useSettingList } from '../../modules/setting/context/hooks';
import { useAuth } from '../../lib/auth-provider/context';

import backgroundImage from '../../assets/images/Graphic Side.png';
import { useListAcademicYear } from '../../modules/school/academic-year/context/hooks';
import { Select } from '../../lib/components';
import { useState } from 'react';
import { useNextGrafeRombel } from '../../modules/school/rombel/context/hooks';
import { PlusSquareIcon } from '@chakra-ui/icons';
import { FiPlus } from 'react-icons/fi';
import { CreateAcademicYear } from '../../modules/school/academic-year/components';

function ProfileHeader({ action }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpenAcademicYears,
    onOpen: onOpenAcademicYears,
    onClose: onCloseAcademicYear,
  } = useDisclosure();
  const [nextGrade, setNextGrade] = useState({ idAcademicYears: '', type: '' });
  const [user] = useAuth((state) => [state.user], shallow);
  const [page, setPage] = useState(1);
  const { data } = useSettingList({
    page,
  });
  const valueData = data?.data;
  const { role, fullName } = user;
  const schoolName = user?.idSchool?.name;
  const { nextGrade: execute, status } = useNextGrafeRombel();
  const {
    data: academicYears,
    refetch,
    // status,
  } = useListAcademicYear({
    limit: 1000,
    queryKey: 'FETCH_ACADEMICYEARS_NAV',
  });
  const academicYearOptions =
    academicYears?.data?.docs?.map((item) => ({
      label: item.fullName,
      value: item.id,
    })) || [];
  const handleNextGrade = async () => {
    await execute(nextGrade);
    onClose();
  };
  console.log({ user });

  return (
    <Box bgImage={`url('${backgroundImage}')`}>
      <Box
        px="40px"
        py="52px"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        textColor="white"
      >
        <Text fontSize="2xl" as="b">
          Hello, {fullName} !
        </Text>
        <Text>Welcome to {schoolName} Dashboard... </Text>
      </Box>
      <Box
        bgColor="white"
        px="24px"
        py="24px"
        borderTopRadius="8px"
        display="flex"
        flexDir={{ base: 'column', md: 'row' }}
        alignItems="center"
        gap="6px"
      >
        <Avatar
          width="100px"
          height="100px"
          mt="-58px"
          name={fullName}
          src={valueData?.photo}
        />
        <Box display="flex" alignItems="center">
          <Text mr="6px" fontSize="xl">
            {fullName}
          </Text>
          <Text color="gray">- {role}</Text>
        </Box>
        {/* <Button onClick={onOpen} size={'sm'}>
          Naik Kelas
        </Button> */}
        <Modal isOpen={isOpen} onClose={onClose}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Naik Kelas</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Box display={'flex'} alignItems={'end'}>
                <Select
                  id="idAcademicYears"
                  placeholder="Pilih Tahun Ajaran"
                  label={'Tahun Ajaran'}
                  // value={academicYear}
                  inputProps={{
                    // ...field,
                    size: 'sm',
                    bgColor: 'white',
                  }}
                  // value={academicYear}
                  onChange={(e) => {
                    // console.log({ e, val: e.target.value });
                    setNextGrade({
                      ...nextGrade,
                      idAcademicYears: e.target.value,
                    });
                  }}
                  options={academicYearOptions}
                />
                <Button size={'sm'} ml={3} onClick={onOpenAcademicYears}>
                  <FiPlus />
                </Button>
              </Box>
              <br />
            </ModalBody>

            <ModalFooter>
              <Button
                size={'sm'}
                bg={'cyan.700'}
                color={'white'}
                isLoading={status == 'fetching'}
                w={'full'}
                mt={3}
                onClick={() => {
                  handleNextGrade();
                }}
              >
                Naik Kelas
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Spacer />
        {action}
      </Box>
      <CreateAcademicYear
        isOpen={isOpenAcademicYears}
        onClose={onCloseAcademicYear}
      />
    </Box>
  );
}

export default ProfileHeader;
